<template>
    <div class="x_box">
        <div class="x_header item-form-header">
            <div class="item-form-title">
                <router-link to="/item">{{ $t('item_list') }}</router-link>
                <h4>{{ pageTitle }}</h4>
            </div>
            <div class="item-form-actions">
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
                <button type="button" class="btn btn-primary btn-sm no-bor" :disabled="isSaving" @click="onSave">
                    <i class="fa fa-floppy-o"></i> {{ $t('save') }}
                </button>
            </div>
        </div>
        <div class="x_body">
            <div class="card f_card item-form-card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ជូលឈ្មោះ</div>
                        <div class="error" v-if="!$v.model.Num.required">- សូមធ្វើការបញ្ជូលលេខកូដ</div>
                    </div>
                    
                    <div class="item-basic-panel">
                        <div class="item-basic-content">
                            <div class="item-img-element">
                                <div class="side-left">
                                    <div class="card-img-top">
                                        <img :src="img" @click="$refs.file.click()" />
                                        <input type="file" ref="file" hidden accept="image/*" @change="fileChange"/>
                                        <button type="button" class="image-action" @click="$refs.file.click()">
                                            <i class="fa fa-camera" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="side-right">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                                        <label class="label-control blue">{{$t('item_name')}}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="$v.model.Name.$model"/>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="label-control blue">{{$t('item_name_en')}}
                                        </label>
                                        <div>
                                            <input type="text" class="form-control form-control-sm" v-model="model.NameEng"/>
                                        </div>
                                    </div>
                                    <div class="item-options">
                                        <div class="form-group">
                                            <label class="toggle-label"><input type="checkbox" v-model="model.CanSold"> {{$t('can_be_sold')}}</label>
                                        </div>
                                        <div class="form-group">
                                            <label class="toggle-label"><input type="checkbox" v-model="model.CanPurchase"> {{$t('can_be_purchase')}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-tabs v-model="activeTab">
                        <b-tab :title="$t('general')">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4 col-lg-3">
                                            <div class="form-group" :class="{ 'form-group-error': $v.model.Num.$error }">
                                                <label class="label-control blue">{{$t('barcode')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <div>
                                                    <input type="text" class="form-control form-control-sm" v-model="$v.model.Num.$model"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-3">
                                            <div class="form-group">
                                                <label class="label-control blue">{{ $t('serialno') }}</label>
                                                <div>
                                                    <input class="form-control form-control-sm" type="text" v-model="model.SerialNum">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-6">
                                            <div class="form-group">
                                                <label class="label-control blue">{{$t('vendor')}}</label>
                                                <div>
                                                    <VendorDropdown @select="vendorSelected" :value="model.VendorName"></VendorDropdown>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="label-control blue">{{ $t('itemtype') }}</label>
                                                <div>
                                                    <select class="form-control form-control-sm" v-model="model.ProductTypeId">
                                                        <option value="1">{{$t('stock_assembly')}}</option>
                                                        <option value="2">{{$t('service')}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                            <div class="form-group" :class="{ 'form-group-error': $v.model.CategoryId.$error }">
                                                <label class="label-control blue">{{ $t('item_category_list') }}</label>
                                                <div>
                                                    <select class="form-control form-control-sm" v-model="model.CategoryId">
                                                        <option value=""></option>
                                                        <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group" :class="{ 'form-group-error': $v.model.UomId.$error }">
                                                <label class="label-control blue">{{ $t('uom') }}</label>
                                                <div>
                                                    <select class="form-control form-control-sm" v-model="model.UomId">
                                                        <option v-for="ret in units" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="label-control blue">{{ $t('model') }}</label>
                                                <div>
                                                    <select class="form-control form-control-sm" v-model="model.BrandId">
                                                        <option value=""></option>
                                                        <option v-for="ret in brands" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label class="label-control blue">{{ $t('base_price_sale') }}</label>
                                                <div>
                                                    <input class="form-control form-control-sm" type="number" v-model="model.Price">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="label-control blue">{{ $t('cost') }}</label>
                                                <div>
                                                    <input class="form-control form-control-sm" type="number" v-model="model.BeginCost">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="label-control blue">{{ $t('begin_stock') }}</label>
                                                <div>
                                                    <input class="form-control form-control-sm" type="number" v-model="model.BeginQty">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="label-control blue">{{ $t('qty_alert') }}</label>
                                                <div>
                                                    <input class="form-control form-control-sm" type="number" v-model="model.AlertQty">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab :title="$t('promotions')">
                            <PromotionCard :promotions="promotions" @delete="handleDeletePromotion" @edit="handleEditPromotion" />
                            <button type="button" class="btn btn-sm btn-primary" @click="openPromotionModal"><i class="fa fa-plus"></i> បង្កើតប្រូម៉ូសិន</button>
                            <PromotionModal :value="promotionObject" :visible.sync="showModal" @save="handleRuleUpdate" />
                        </b-tab>
                        <b-tab :title="$t('accounting')">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.IncomeAccountId.$error }">
                                        <label class="label-control blue">{{ $t('income_acount_id') }}</label>
                                        <div>
                                            <CoaSelect :v-store="isStore" :value="model.IncomeAccountName" @select="coaSelect(1, $event)"></CoaSelect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.ExpenseAccountId.$error }">
                                        <label class="label-control blue">{{ $t('expense_account_id') }}</label>
                                        <div>
                                            <CoaSelect :v-store="isStore" :value="model.ExpenseAccountName" @select="coaSelect(2, $event)"></CoaSelect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.StockAccountId.$error }">
                                        <label class="label-control blue">{{ $t('stock_account_id') }}</label>
                                        <div>
                                            <CoaSelect :v-store="isStore" :value="model.StockAccountName" @select="coaSelect(3, $event)"></CoaSelect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="label-control blue">{{ $t('include_tax') }}</label>
                                        <div>
                                            <input class="form-control form-control-sm" type="number" v-model="model.IncludeTax">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import CoaSelect from '../Accountings/CoaSelect';
import { VendorDropdown } from '../Vendors';
import PromotionCard from './Components/PromotionCard.vue';
import PromotionModal from './Components/PromotionModal.vue';
export default {
    components: { CoaSelect, VendorDropdown, PromotionCard, PromotionModal },
    data() {
        return {
            model: {
                Num: '',
                Name: '',
                NameEng: '',
                Description: '',
                ProductTypeId: '1',
                CategoryId: '',
                CanSold: true,
                CanPurchase: true,
                Image: '',
                BeginCost: 0,
                Price: 0,
                AlertQty: 0,
                BeginQty: 0,
                UomId: '',
                BrandId: '',
                IncludeTax: 0,
                StockAccountId: '',
                StockAccountName: '',
                ExpenseAccountId: '',
                ExpenseAccountName: '',
                IncomeAccountId: '',
                IncomeAccountName: '',
                VendorId: ''
            },
            categories: [],
            units: [],
            brands: [],
            img: '/img/no-image.svg',
            actionLink: 'item/save',
            formHead: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            isStore: true,
            activeTab: 0,
            showModal: false,
            isSaving: false,
            previewUrl: '',
            promotions: [],
            editingPromotionIndex: null,
            promotionObject: null
        }
    },
    validations:{
        model: {
            Name: { required },
            Num: { required },
            CategoryId: { required },
            UomId: { required },
            StockAccountId: { required },
            ExpenseAccountId: { required },
            IncomeAccountId: { required }
        }
    },
    created: function() {
        this.loadForm();
    },
    beforeDestroy(){
        this.revokePreviewUrl();
    },
    methods: {
        async loadForm(){
            await this.initialize();
            let id = this.$route.params.id;
            if(id != undefined){
                let loading = this.$loading.show();
                this.actionLink = 'item/update';
                this.$api().post('item/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                        if(this.model.Image){
                            this.img = this.$base() + 'image/items/' + this.model.Image;
                        }
                        this.promotions = (res.data.Json.Promotions || []).map(this.normalizePromotion);
                        this.filterAccountName();
                    }
                }).finally(function() { loading.hide(); });
            }else {
                this.filterAccount();
            }
        },
        initialize(){
            let loading = this.$loading.show();
            return this.$api().post('item/initialize').then((res) => {
                    if(this.$isValid(res)){
                        var json = res.data.Json;
                        this.$store.state.accounts = json.Accounts;
                        this.categories = json.Categories;
                        this.units = json.Uoms;
                        this.brands = json.Brands;
                        this.setDefaultSelects();
                    }
                }).finally(function(){ loading.hide(); });
        },
        async onSave() {
            this.$v.$touch();
            if (this.$v.$invalid) return;
            if (this.isSaving) return;

            const loading = this.$loading.show();
            this.isSaving = true;

            try {
                const formData = new FormData();

                if (this.$refs.file && this.$refs.file.files.length > 0) {
                    formData.append('File', this.$refs.file.files[0]);
                }

                if (this.actionLink === 'item/update') {
                    formData.append("Id", this.model.Id);
                }

                formData.append("Item", JSON.stringify(this.model));
                formData.append("Promotions", JSON.stringify(this.promotions.map(this.toPromotionPayload)));

                const res = await this.$api().post(
                    this.actionLink,
                    formData,
                    this.formHead
                );

                if (this.$isValid(res)) {
                    this.$router.push("/item");
                }

            } catch (err) {
                this.$swal.fire({
                    type: 'error',
                    title: 'រក្សាទុកមិនបាន',
                    text: err && err.message ? err.message : 'សូមព្យាយាមម្តងទៀត។'
                });
            } finally {
                this.isSaving = false;
                loading.hide();
            }
        },
        fileChange(e) {
            const file = e.target.files && e.target.files[0];
            if(!file) return;
            this.revokePreviewUrl();
            this.previewUrl = URL.createObjectURL(file);
            this.img = this.previewUrl;
        },
        revokePreviewUrl(){
            if(this.previewUrl){
                URL.revokeObjectURL(this.previewUrl);
                this.previewUrl = '';
            }
        },
        setDefaultSelects(){
            if(!this.model.CategoryId && this.categories.length > 0){
                this.model.CategoryId = this.categories[0].Id;
            }
            if(!this.model.UomId && this.units.length > 0){
                this.model.UomId = this.units[0].Id;
            }
        },
        coaSelect(n, sender){
            if(n == 1){
                this.model.IncomeAccountId = sender.Id;
                this.model.IncomeAccountName = sender.Name;
            }else if(n == 2){
                this.model.ExpenseAccountId = sender.Id;
                this.model.ExpenseAccountName = sender.Name;
            }else if(n == 3){
                this.model.StockAccountId = sender.Id;
                this.model.StockAccountName = sender.Name;
            }
        },
        filterAccount: function() {
            let accounts = this.$store.state.accounts;
            let isSale = false;
            let isAsset = false;
            let isExpense = false;
            for(var i = 0; i < accounts.length; i++){
                let item = accounts[i];
                if(item.Name == 'Sale'){
                    this.model.IncomeAccountId = item.Id;
                    this.model.IncomeAccountName = item.Name;
                    isSale = true;
                }else if(item.Name == 'Cost of Goods Sold'){
                    this.model.ExpenseAccountId = item.Id;
                    this.model.ExpenseAccountName = item.Name;
                    isExpense = true;
                }else if(item.Name == 'Inventory Asset'){
                    this.model.StockAccountId = item.Id;
                    this.model.StockAccountName = item.Name;
                    isAsset = true;
                }
                if(isSale && isAsset && isExpense){
                    break;
                }
            }
        },
        filterAccountName: function(){
            let accounts = this.$store.state.accounts;
            let isSale = false;
            let isAsset = false;
            let isExpense = false;
            for(var i = 0; i < accounts.length; i++){
                let item = accounts[i];
                if(item.Id == this.model.IncomeAccountId){
                    this.model.IncomeAccountName = item.Name;
                    isSale = true;
                }else if(item.Id == this.model.ExpenseAccountId){
                    this.model.ExpenseAccountName = item.Name;
                    isExpense = true;
                }else if(item.Id == this.model.StockAccountId){
                    this.model.StockAccountName = item.Name;
                    isAsset = true;
                }
                if(isSale && isAsset && isExpense){
                    break;
                }
            }
        },
        vendorSelected(item){
            this.model.VendorId = item ? item.Id : '';
        },
        openPromotionModal(){
            this.editingPromotionIndex = null;
            this.promotionObject = null;
            this.showModal = true;
        },
        handleRuleUpdate(newPromo) {
            const normalizedPromo = this.normalizePromotion(newPromo);
            if(this.editingPromotionIndex !== null){
                const currentPromo = this.promotions[this.editingPromotionIndex] || {};
                const promoToSave = {
                    ...currentPromo,
                    ...normalizedPromo,
                    Id: normalizedPromo.Id || currentPromo.Id || currentPromo.id,
                    ItemId: normalizedPromo.ItemId || currentPromo.ItemId || currentPromo.itemId || this.model.Id
                };
                this.promotions.splice(this.editingPromotionIndex, 1, promoToSave);
                this.editingPromotionIndex = null;
                this.promotionObject = null;
                return;
            }
            if(normalizedPromo.Id){
                let index = this.promotions.findIndex(p => p.Id === normalizedPromo.Id);
                if(index !== -1){
                    this.promotions.splice(index, 1, normalizedPromo);
                }
                return;
            }
            this.promotions.push(normalizedPromo);
        },
        handleDeletePromotion(index) {
            this.$swal.fire({
                title: this.$t('confirm_delete'),
                text: this.$t('confirm_delete_message'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('agree'),
                cancelButtonText: this.$t('cancel')
            }).then((result) => {
                if (result.value) {
                    this.promotions.splice(index, 1);
                }
            });
        },
        handleEditPromotion(index) {
            const promo = this.promotions[index];
            if(!promo) return;
            this.editingPromotionIndex = index;
            this.promotionObject = this.normalizePromotion(promo);
            this.showModal = true;
        },
        normalizePromotion(promo){
            const ruleType = this.normalizeRuleType(promo ? promo.RuleType : 1);
            const id = this.promotionValue(promo, 'Id');
            const itemId = this.promotionValue(promo, 'ItemId');
            return {
                ...(promo || {}),
                ...(id ? { Id: id } : {}),
                ...(itemId || this.model.Id ? { ItemId: itemId || this.model.Id } : {}),
                RuleType: ruleType,
                StartDate: this.formatPromotionDate(this.promotionValue(promo, 'StartDate')),
                EndDate: this.formatPromotionDate(this.promotionValue(promo, 'EndDate')),
                IsActive: this.promotionValue(promo, 'IsActive') === false ? false : true,
                Priority: Number(this.promotionValue(promo, 'Priority') || 0),
                JsonObject: this.normalizePromotionLines(ruleType, this.promotionValue(promo, 'JsonObject'))
            };
        },
        toPromotionPayload(promo){
            const normalized = this.normalizePromotion(promo);
            const payload = {
                ...normalized,
                JsonObject: this.normalizePromotionLines(normalized.RuleType, normalized.JsonObject)
            };

            if(!payload.Id) delete payload.Id;
            if(!payload.ItemId) delete payload.ItemId;
            delete payload.id;
            delete payload.itemId;
            delete payload.startDate;
            delete payload.endDate;
            delete payload.ruleType;
            delete payload.jsonObject;
            delete payload.isActive;
            delete payload.priority;

            return payload;
        },
        promotionValue(source, field){
            if(!source) return undefined;
            if(source[field] !== undefined) return source[field];
            const camelField = field.charAt(0).toLowerCase() + field.slice(1);
            if(source[camelField] !== undefined) return source[camelField];
            const snakeField = field.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).replace(/^_/, '');
            if(source[snakeField] !== undefined) return source[snakeField];
            return undefined;
        },
        normalizeRuleType(ruleType){
            const numericType = Number(ruleType);
            if(!isNaN(numericType) && numericType > 0) return numericType;
            const text = String(ruleType || '').toUpperCase();
            if(text.indexOf('QUANTITY') >= 0) return 1;
            if(text.indexOf('FREE') >= 0 || text.indexOf('GET') >= 0) return 2;
            if(text.indexOf('BUNDLE') >= 0 || text.indexOf('SPECIAL') >= 0) return 3;
            return 1;
        },
        formatPromotionDate(value){
            if(!value) return this.$now().format('YYYY-MM-DD');
            const rawValue = String(value).substr(0, 10);
            if(/^\d{4}-\d{2}-\d{2}$/.test(rawValue)) return rawValue;
            if(/^\d{2}\/\d{2}\/\d{4}$/.test(rawValue)){
                const parts = rawValue.split('/');
                return `${parts[2]}-${parts[0]}-${parts[1]}`;
            }
            return this.$format(value, 'YYYY-MM-DD');
        },
        normalizePromotionLines(ruleType, lines){
            const sourceLines = Array.isArray(lines) ? lines : [];
            return sourceLines.map(line => {
                if(ruleType === 1){
                    return {
                        MinQty: line.MinQty || line.minQty || 1,
                        MaxQty: line.MaxQty || line.maxQty || '',
                        Price: line.Price || line.price || 0
                    };
                }
                if(ruleType === 2){
                    return {
                        MinQty: line.MinQty || line.minQty || 1,
                        ItemId: line.ItemId || line.itemId || '',
                        ItemName: line.ItemName || line.itemName || ''
                    };
                }
                if(ruleType === 3){
                    return {
                        ItemId: line.ItemId || line.itemId || '',
                        ItemName: line.ItemName || line.itemName || '',
                        Price: line.Price || line.price || 0
                    };
                }
                return line;
            });
        }
    },
    computed: {
        pageTitle(){
            return this.$route.params.id == undefined ? this.$t('create_new_item') : 'Update item info';
        }
    }
};
</script>

<style scoped>
    .item-form-header{
        align-items: center;
        display: flex;
        justify-content: space-between;
        gap: 12px;
        padding: 10px 12px;
    }
    .item-form-title a{
        color: #6b7280;
        display: inline-block;
        font-size: 12px;
        margin-bottom: 2px;
    }
    .item-form-title h4{
        color: #0856ab;
        font-size: 17px;
        font-weight: 700;
        line-height: 1.25;
        margin: 0;
    }
    .item-form-actions{
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        justify-content: flex-end;
    }
    .item-form-card{
        border: 1px solid #dfe7f1;
        border-radius: 6px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    }
    .item-basic-panel{
        background: #f8fbff;
        border: 1px solid #dce9f8;
        border-radius: 6px;
        margin-bottom: 14px;
        padding: 12px;
    }
    .item-basic-content{
        max-width: 760px;
    }
    .item-img-element{
        display: flex;
        gap: 14px;
    }
    .item-img-element .card-img-top{
        background: #fff;
        border: 1px solid #d7e3f2;
        border-radius: 6px;
        height: 132px;
        position: relative;
        overflow: hidden;
        width: 132px;
    }
    .item-img-element img{
        cursor: pointer;
        height: 100%;
        object-fit: contain;
        padding: 8px;
        width: 100%;
    }
    .image-action{
        align-items: center;
        background: rgba(8, 86, 171, 0.9);
        border: 0;
        border-radius: 5px;
        bottom: 7px;
        color: #fff;
        display: inline-flex;
        height: 28px;
        justify-content: center;
        position: absolute;
        right: 7px;
        width: 28px;
    }
    .item-img-element .side-right{
        width: 100%;
    }
    .item-options{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }
    .item-options .form-group{
        margin-bottom: 0;
    }
    .toggle-label{
        align-items: center;
        background: #fff;
        border: 1px solid #dce9f8;
        border-radius: 5px;
        color: #334155;
        display: inline-flex;
        gap: 6px;
        margin-bottom: 0;
        padding: 6px 9px;
    }
    .item-form-card /deep/ .nav-tabs{
        border-bottom: 1px solid #dfe7f1;
        margin-bottom: 12px;
    }
    .item-form-card /deep/ .nav-tabs .nav-link{
        border: 0;
        color: #64748b;
        font-weight: 600;
        padding: 8px 12px;
    }
    .item-form-card /deep/ .nav-tabs .nav-link.active{
        border-bottom: 2px solid #0856ab;
        color: #0856ab;
    }
    .form-group{
        margin-bottom: 12px;
    }
    .form-control{
        border-color: #d7e3f2;
        border-radius: 4px;
    }
    @media (max-width: 575.98px){
        .item-form-header,
        .item-form-actions,
        .item-img-element{
            align-items: stretch;
            flex-direction: column;
        }
        .item-form-actions .btn{
            width: 100%;
        }
        .item-img-element .card-img-top{
            width: 100%;
        }
    }
</style>
